exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-MajorMessage {\n  display: flex;\n  min-height: 20em;\n  align-items: center;\n  padding: 2em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/MajorMessage/MajorMessage.less
// module id = 848
// module chunks = 0